export class SearchCriteria{
    public FromReceiveDate : Date = null;
    public ToReceiveDate : Date = null;
    public OrderStatus : Number;
    public CountryCode : Number;
}


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/models/finance.model.ts